import React from 'react'; 
import WarningIcon from '@material-ui/icons/Warning';
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";

import {UserRoles} from "../../../utils/roles";
import {Statuses, StatusesOptions} from "../../../utils/actStatuses";
import {NavigationButtons} from "../../NavigationButtons/NavigationButtons";
import {makeStyles} from "@material-ui/core";
import { SearchSignature } from '../ActFillingHeader/ActFillingHeader';
import { useDialog } from '../../../hooks/useDialog';
import { Dialog } from '../../Dialog/Dialog';


export const useStyles = makeStyles(() => ({
    greenButton: {
        color: '#0A8100',
        border: '1px solid #0A8100'
    },
    smallButtonLabel: {
        fontSize: '1.125rem',
        fontWeight: 400,
        lineHeight: '21px',
        letterSpacing: '0.00714em',
        textTransform: 'none',
        display: 'inline'
    }
}))



export const GreenButton = ({children, onClick}) => {
    const classes = useStyles()

    return <Button onClick={onClick} variant="outlined"
                   classes={{outlined: classes.greenButton}}>
        <Typography variant={'body1'}
                    classes={{body1: classes.smallButtonLabel}}>
            {children}
        </Typography>
    </Button>
}

const StatusSelect = ({value, onChange}) =>{


   
                                            return(
                                                <>
                                                {value === Statuses.STATUS_SIGNED ?
                                                <Typography variant='h6' style={{color: 'red'}}>Акт подписан!!!</Typography>
                                                :
                                                <TextField style={{minWidth: '159px'}}
                                                       id={'status-select'}
                                                       value={value}
                                                       label={'Статус акта'}
                                                       onChange={onChange}
                                                       variant={"outlined"}
                                                       size={"small"}
                                                       select
>
    {StatusesOptions.map(el => {if (el.value !== Statuses.STATUS_SIGNED) return <MenuItem key={`status-item-${el.value}`}
                                         value={el.value}>
        {el.label}
    </MenuItem>})}
</TextField>}</>)

    }

const ApproveButton = ({onClick}) => <GreenButton onClick={onClick}>
    Сохранить черновик
</GreenButton>

const AdminSaveButton = ({onClick}) => <GreenButton onClick={onClick}>
    Сохранить черновик
</GreenButton>


const SaveButtonLock = ({onClick, onClose}) => {

    const {open, handleClose, handleOpen} = useDialog();

    return (
        <>
            <GreenButton onClick={handleOpen}>
                    Сохранить и подписать
            </GreenButton>
            <Dialog
                open={open}
                title={'Вы готовы подписать акт?'}
                handleClose={handleClose}
                fullWidth
                maxWidth={'sm'}
        >   
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <WarningIcon
                    style={{
                        width: '50px',
                        height: '50px',
                        color: 'red'
                    }}
                />
                <Typography variant='h6' style={{color: 'red', marginLeft: '10px'}}>
                     Изменение акта будет ограничено!!!
                </Typography>
            </div>
            <div
                style={{display: 'flex', justifyContent: 'space-between', marginTop: '30px'}}
            >
                <Button 
                    onClick={() => {handleClose(); onClose();}}
                    variant="outlined"
                    color="primary"

                >
                    Отменить подписи
                </Button>
                <GreenButton onClick={onClick}>
                    Завершить и подписать для всех
                </GreenButton>
            </div>
        </Dialog>
        </>
       
    )
}

const getActFillingFooterElements = (role,
                                     isStaff,
                                     status,
                                     activeStep,
                                     handleStatusChange,
                                     handleCreateActButton,
                                     handleAdminSaveButton,
                                     pole,
                                     actTempl,
                                     setFieldValue,
                                     values,
                                     handleAdminSaveButtonLock,
                                     handleCreateActButtonLock,
                                     
) => {

   
   

    const FlagLock = () => {
        let flag = false

        const raw = pole.pole
        const template = actTempl.actTempl
        const mass = SearchSignature(template)
        let temp = template.filter(pole => pole.type === 'signature-field')

        mass.map((el) => {
            let sign = raw.filter(pole => pole.name === el )
           
            let temp_for_sign = temp.filter(pole => pole.variable === el)
            
            

            if (temp_for_sign[0].content.required && sign[0].value !== "") {
                flag = true
            } else if (sign[0].value === "" && temp_for_sign[0].content.required) {
                flag = false
            }
        })
        return flag
    }

    const handleCleanSignature = () => {
        let value = values.values
        const template = actTempl.actTempl
        const mass = SearchSignature(template)

        mass.map((el) => {
            
            value[el] = ""
        })

        setFieldValue(value)
        
    }
    
  
    if ((isStaff || (role === UserRoles.EDITOR)) && FlagLock()) {
        return <>
            <Grid item>
                <StatusSelect value={status} onChange={handleStatusChange}/>
            </Grid>
            <Grid item>
                <SaveButtonLock onClick={handleAdminSaveButtonLock} onClose={handleCleanSignature}/>
            </Grid>
        </>
    }
    if ((isStaff || (role === UserRoles.EDITOR))) {
        return <>
            <Grid item>
                <StatusSelect value={status} onChange={handleStatusChange}/>
            </Grid>
            <Grid item>
                <AdminSaveButton onClick={handleAdminSaveButton}/>
            </Grid>
        </>
    }
    if (FlagLock()) {
        if (((role === UserRoles.PROJECT_MANAGER) || (role === UserRoles.MODERATOR)) && status != Statuses.APPROVED_STATUS ) 
        return <>
        <Grid item>
            <AdminSaveButton onClick={handleAdminSaveButton}/>
        </Grid>
        </>
        if (role === UserRoles.SUPERVISOR && FlagLock()) {
            if (activeStep === 2) {
                return <Grid item><SaveButtonLock onClick={handleCreateActButtonLock} onClose={handleCleanSignature}/></Grid>
            }
        } 

        // if (role === UserRoles.SUPERVISOR) {
        //     if (activeStep === 2) {
        //         return <Grid item><ApproveButton onClick={handleCreateActButton}/></Grid>
        //     }
        // }
    } else {
        if (activeStep === 2) {
            return <Grid item><ApproveButton onClick={handleCreateActButton}/></Grid>
        }
    }
}

export const ActFillingFooter = ({
                                     activeStep,
                                     nextStep,
                                     prevStep,
                                     role,
                                     isStaff,
                                     status,
                                     handleStatusChange,
                                     handleCreateActButton,
                                     handleAdminSaveButton,
                                     pole,
                                     actTempl,
                                     setFieldValue,
                                     values,
                                     handleAdminSaveButtonLock,
                                     handleCreateActButtonLock,
                                 }) => {
                             
    

    return <Grid container item justifyContent={"flex-start"} spacing={4} alignItems={"center"}>
        <NavigationButtons activeStep={activeStep} nextStep={nextStep} prevStep={prevStep}/>
        <Grid item container xs justifyContent={"flex-end"} spacing={4} alignItems={"center"}>
            {getActFillingFooterElements(
                role,
                isStaff,
                status,
                activeStep,
                handleStatusChange,
                handleCreateActButton,
                handleAdminSaveButton,
                pole={pole},
                actTempl={actTempl},
                setFieldValue,
                values={values},
                handleAdminSaveButtonLock,
                handleCreateActButtonLock,
            )}
        </Grid>
    </Grid>
}